import { render, staticRenderFns } from "./VersionDetailDialog.vue?vue&type=template&id=04424bae&scoped=true&"
import script from "./VersionDetailDialog.vue?vue&type=script&lang=js&"
export * from "./VersionDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./VersionDetailDialog.vue?vue&type=style&index=0&id=04424bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04424bae",
  null
  
)

export default component.exports